import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  section: { paddingTop: '50px', paddingBottom: '50px' },

  formContainer: {
    paddingLeft: 15,
    paddingRight: 15,
  },
  loader: {
    color: 'green',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  submitted: { display: 'none !important' },
  sent: {
    padding: '22px 22px 55px',
    border: 'solid 2px #0d6930',
    '& submitBtn': { display: 'none' },
    '.& .submitted': {
      display: 'block !important',
      borderColor: '#279852 !important',
    },
  },
  myTextField: {
    width: '100%',
  },
  formControl: {
    marginBottom: '15px',
  },

  submitBtn: {
    backgroundColor: '#fe5a35',
    color: '#ffffff',
    transition: '0.3s',
    width: '100%',
    border: '1px solid #fe5a35',
    height: '45px',
    '&:hover': { backgroundColor: '#ff6a49' },
  },

  formBox: { '& form': { marginTop: '35px' } },
  infoText: {
    '& p': {
      maxWidth: '480px',
      textAlign: 'center',
      margin: '36px auto 0',
      padding: '0 10px',
    },
  },
  [theme.breakpoints.up('sm')]: {
    header: { '& h2': { textAlign: 'left' } },

    formBox: {
      padding: '40px 34px 56px',
      border: 'solid 4px #000000',
      maxWidth: '479px',
      margin: 'auto',
      '& form': { padding: '0 16px' },
    },
    sent: { border: 'solid 4px #0d6930' },

    submitBtn: { fontSize: '16px', height: '70px' },
    formControl: {
      marginBottom: '20px',
    },
  },

  [theme.breakpoints.up('md')]: {
    formContainer: { gridTemplateColumns: '1fr 1fr', gridGap: '100px' },
    formControl: { marginBottom: '15px' },
    formBox: { padding: '54px 95px', maxWidth: '800px' },
    infoText: {
      '& p': { maxWidth: '508px', marginTop: '56px', padding: '0 70px' },
    },
    submitBtn: {
      width: '392px',
      margin: 'auto',
      display: 'block',
    },
  },
}));

export default style;
